module.exports = __webpack_public_path__ + "img/9788981339531.7b696174.jpg";